import React, { useState, useEffect, useRef } from "react";
import { Button, } from "react-bootstrap";

import "./subscriptions.scss";

export function getModalHeaderAndBody(clientName, fromSubscription, toSubscription) {
  let modalData = { header: "", body: "" };

  if (fromSubscription === "prospect" && toSubscription === "standard") {
    modalData.header = "Upgrade to Standard License";
    modalData.body = (
      <>
        Upgrade <span className="f-600 f-black">{clientName} </span>
        from a <span className="f-600 f-black">Prospect License</span> to a{" "}
        <span className="f-600 f-black">Standard License</span>. This will also
        change their company type from Prospect to Client.
      </>
    );
  }
  if (fromSubscription === "standard" && toSubscription === "premium") {
    modalData.header = "Upgrade to Premium License";
    modalData.body = (
      <>
        Upgrade <span className="f-600 f-black">{clientName} </span>
        from a <span className="f-600 f-black">Standard License</span> to a{" "}
        <span className="f-600 f-black">Premium License</span>. This license
        will be billable over and above your MSPs baseline package.
      </>
    );
  }
  if (fromSubscription === "prospect" && toSubscription === "premium") {
    modalData.header = "Upgrade to Premium License";
    modalData.body = (
      <>
        Upgrade <span className="f-600 f-black">{clientName} </span>
        from a <span className="f-600 f-black">Prospect License</span> to a{" "}
        <span className="f-600 f-black">Premium License</span>. This will also
        change their company type from Prospect to Client. This license will be
        billable over and above your MSPs baseline package.
      </>
    );
  }
  if (fromSubscription === "standard" && toSubscription === "prospect") {
    modalData.header = "Downgrade to Prospect License";
    modalData.body = (
      <>
        Downgrade <span className="f-600 f-black">{clientName} </span>
        from a <span className="f-600 f-black">Standard License</span> to a{" "}
        <span className="f-600 f-black">Prospect License</span>.This will also
        change their company type from Client to Prospect.
      </>
    );
  }
  if (fromSubscription === "premium" && toSubscription === "prospect") {
    modalData.header = "Downgrade to a Prospect License";
    modalData.body = (
      <>
        Downgrade <span className="f-600 f-black">{clientName} </span>
        from a <span className="f-600 f-black">Premium License</span> to a{" "}
        <span className="f-600 f-black">Prospect License</span>. This will also
        change their company type from Client to Prospect. This prospect license
        will come from your prospect license pool which is included within your
        MSPs baseline package, and this premium license will no longer be
        billable at your next billing cycle.
      </>
    );
  }
  if (fromSubscription === "premium" && toSubscription === "standard") {
    modalData.header = "Downgrade to a Standard License";
    modalData.body = (
      <>
        Downgrade <span className="f-600 f-black">{clientName} </span>
        from a <span className="f-600 f-black">Premium License</span> to a{" "}
        <span className="f-600 f-black">Standard License</span>. This basic license will come from your standard license pool which is included within your MSPs baseline package, and this standard license will no longer be billable at your next billing cycle.
      </>
    );
  }

  return modalData;
}
